import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_apparel_preorder: FaireCategoryEntity = {
  token: "cat_apparel-preorder",
  type: "category",
  name: "Pre-order Fall/Winter '24",
  level: 2,
  parentToken: "cat_apparel",
  href: "/category/apparel/preorder-fw24",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
